import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/common/ui/alert-dialog";

interface DisconnectDialogProps {
  provider: string | null;
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DisconnectDialog({
  provider,
  open,
  onConfirm,
  onCancel,
}: DisconnectDialogProps): React.ReactElement {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent data-testid="disconnect-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Disconnect {provider}?</AlertDialogTitle>
          <AlertDialogDescription>
            This will remove your {provider} connection. You can reconnect at any time.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="disconnect-cancel" onClick={onCancel}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction data-testid="disconnect-confirm" onClick={onConfirm}>
            Disconnect
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
